"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERRORS_DOMAIN = exports.STORAGE_GLOBAL_KEY = void 0;
exports.STORAGE_GLOBAL_KEY = '_cianGlobalBehaviors';
exports.ERRORS_DOMAIN = 'GlobalBehaviors';
//# sourceMappingURL=constants.js.map